import React from "react";
import { Shell } from "./UI";

export default function LoadingScreen() {
  return (
    <Shell>
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-indigo-600 border-r-transparent"></div>
          <div className="mt-4 text-slate-600">Loading data...</div>
        </div>
      </div>
    </Shell>
  );
}
